/**
 * Единый источник временных id для ещё не сохранённых блоков контента новости.
 *
 * До этого News.vue (getNextTemporaryContentId) и ContentEditor.vue (newItemId)
 * генерировали отрицательные id независимо друг от друга, каждый начиная с -1.
 * Как только оба счётчика выдавали одно и то же значение (типичный случай —
 * первый абзац статьи и первая синхронизация картинки анонса), в content
 * оказывались два разных блока с одинаковым id, а поиск блока по id
 * (ContentEditor.editItem) находил первый попавшийся - обычно не тот, что
 * пользователь пытался открыть.
 *
 * Счётчик - синглтон модуля: любой файл, импортирующий createTempContentId,
 * получает значения из одной и той же последовательности, поэтому два разных
 * компонента больше не могут выдать одинаковый id.
 *
 * Значение всегда строго отрицательное целое число - backend (ContentService::update)
 * различает существующие/новые блоки по знаку id ($n['id'] > 0 - апдейт существующей
 * записи, $n['id'] < 0 - создание новой), так что тип и знак id менять нельзя.
 */
let counter = 0;

export function createTempContentId () {
    counter -= 1;
    return counter;
}

/**
 * Только для тестов - сбрасывает счётчик, чтобы тесты не зависели друг от друга.
 */
export function resetTempContentIdForTests () {
    counter = 0;
}
